import QTable from 'quasar/src/components/table/QTable.js';

export const adminInvoiceForModelTableColumns = (): QTable['columns'] => [
  {
    name: 'id',
    field: 'id',
    label: 'شماره فاکتور',
    align: 'center'

  },
  {
    name: 'title',
    field: 'title',
    label: 'عنوان',
    align: 'center',
    style: 'max-width: 250px;'
  },
  {
    name: 'payable',
    field: 'payable',
    label: 'مقدار',
    align: 'center',
    format: value => value?.toLocaleString() || value
  },
  {
    name: 'persian_status',
    field: 'persian_status',
    label: 'وضعیت',
    align: 'center'
  },
  {
    name: 'persian_person_type',
    field: 'persian_person_type',
    label: 'نوع فاکتور',
    align: 'center'
  },
  {
    name: 'due_date',
    field: 'due_date',
    label: 'تاریخ سررسید',
    align: 'center'
  },
  {
    name: 'paid_at',
    field: 'paid_at',
    label: 'تاریخ پرداخت',
    align: 'center'
  },
  {
    name: 'download',
    field: 'download',
    label: 'دانلود فاکتور',
    align: 'center'
  }
]
